import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=0ca9fd0a&scoped=true&"
import script from "./EditProfileForm.vue?vue&type=script&lang=ts&"
export * from "./EditProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditProfileForm.vue?vue&type=style&index=0&id=0ca9fd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9fd0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField,VTextarea})
